import React from 'react';
import logo from './../images/logo.svg';

function Logo({title, onClick}) {
  return <img onClick={onClick} className="logo" alt={title} src={logo} />;
}

export default Logo;
